module.exports = require("fs");


//////////////////
// WEBPACK FOOTER
// external "fs"
// module id = 29
// module chunks = 0